const defaultValidationOptions = {
  errorLabelClassName: 'form-error',
  errorInputClassName: 'error',
};

export function validateForm(form, options = defaultValidationOptions) {
  const opts = { ...defaultValidationOptions, ...options };

  // Remove previous error messages
  Array.prototype.forEach.call(
    form.getElementsByClassName(opts.errorLabelClassName),
    (elem) =>
      elem.parentNode &&
      elem.parentNode.removeChild(
        elem.parentNode.childNodes[
          Array.prototype.indexOf.call(elem.parentNode.childNodes, elem)
        ]
      )
  );

  // Check validation for each field present in the DOM
  const invalidFields = [];
  for (let i = 0; i < form.elements.length; i++) {
    const inputElem = form.elements[i];
    if (
      inputElem.name &&
      typeof inputElem.checkValidity === 'function' &&
      !inputElem.checkValidity()
    ) {
      // Generate error text based on input's placeholder, name, or ID
      const errorLabel = document.createElement('p');
      const inputName =
        inputElem.placeholder || inputElem.name || inputElem.id || 'A value';
      errorLabel.innerText = `${inputName.replace(/^(.)/, (c) =>
        c.toUpperCase()
      )} is required`;
      errorLabel.className = opts.errorLabelClassName;
      inputElem.classList.add(opts.errorInputClassName);
      inputElem.insertAdjacentElement('afterend', errorLabel);
      invalidFields.push(inputName);
    } else {
      inputElem.classList.remove(opts.errorInputClassName);
    }
  }

  // if no fields are invalid, the form is valid
  return invalidFields.length === 0;
}

function getElementPath(elem) {
  const nodes = [];
  let cur = elem;
  while (cur.parentElement) {
    nodes.push(cur);
    cur = cur.parentElement;
  }
  return nodes;
}

export function isInputElementEvent(evt) {
  const nodes = getElementPath(evt.target);
  for (let i = 0; i < nodes.length; i++) {
    const { nodeName } = nodes[i];
    if (
      nodeName === 'INPUT' ||
      nodeName === 'SELECT' ||
      nodeName === 'TEXTAREA'
    )
      return true;
  }
  return false;
}
